<template>
    <div class="search">
        <!-- <h2 class="text-center">Wybierz model z oferty samochodów używanych</h2>
        <div class="contact-mobile">
            <h2 class="text-center">
            Dowiedz się więcej
            </h2>
            <h3 class="text-center search-phone">
                tel.: <a href="tel:618491140">618 491 140</a>
            </h3>
        </div> -->
        <!-- <div class="search-cars">
            <div class="search-cars-item" v-on:click="downloadModel('75')" v-bind:class="{ 'active' : getCurrentModel =='a1'}">
                <img src="@/assets/a1.png" alt="">
                <span>A1</span>
            </div>
            <div class="search-cars-item" v-on:click="downloadModel('a3-limousine,a3-sportback,s3-sportback')" v-bind:class="{ 'active' : getCurrentModel =='a3-limousinea3-sportback,s3-sportback'}">
                <img src="@/assets/a3.png" alt="">
                <span>A3</span>
            </div>
            <div class="search-cars-item" v-on:click="downloadModel('78')" v-bind:class="{ 'active' : getCurrentModel =='a4'}">
                <img src="@/assets/a4.png" alt="">
                <span>A4</span>
            </div>
            <div class="search-cars-item" v-on:click="downloadModel('a5')" v-bind:class="{ 'active' : getCurrentModel =='a5'}">
                <img src="@/assets/a5.png" alt="">
                <span>A5</span>
            </div>
            <div class="search-cars-item" v-on:click="downloadModel('81,82')" v-bind:class="{ 'active' : getCurrentModel =='a6a6-allroad'}">
                <img src="@/assets/a6.png" alt="">
                <span>A6</span>
            </div>
            <div class="search-cars-item" v-on:click="downloadModel('87')" v-bind:class="{ 'active' : getCurrentModel =='q5'}">
                <img src="@/assets/q5.png" alt="">
                <span>Q5</span>
            </div>
            <div class="search-cars-item" v-on:click="downloadModel('88')" v-bind:class="{ 'active' : getCurrentModel =='q7'}">
                <img src="@/assets/q7.png" alt="">
                <span>Q7</span>
            </div>
        </div> -->
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'search',
  data(){
      return{

      }
  },
  methods: {
      ...mapActions(['downloadOffers','downloadModel'])
  },
  computed: {
      ...mapGetters(['getCurrentModel'])
  },
  mounted() {
      this.downloadOffers();
  }
}
</script>

<style lang="scss" scoped>
    .search{
        width: 100%;
        
        // padding:3rem 1rem;
        @media(max-width:780px){
                    padding:1rem 1rem 3rem 1rem;
        }
        &-cars{
            display: flex;
            justify-content: space-around;
            align-items: baseline;
            margin-top: 3rem;
            cursor: pointer;
            img{
                max-width: 90%;
                margin: 0 auto;
            }
            span{
                font-weight:bold;
                display: block;
                text-align: center;
            }
            &-item{
                width: 100%;
                &.active{
                    color: #bb0a30;
                }
            }
        }
        .search-phone{
            font-size: 1.5rem;
            margin: 0;
            a{
                text-decoration: none;
            }
        }
    }
    .contact-mobile{
        display: none;
        @media(max-width: 780px){
            display: block;
            color: #fff;
            background: #bb0a30;
            padding: 1.5rem 1rem;
            h2{
                padding: 0;
                margin: 0;
            }
            a{
                color: #fff;
            }
        }
    }
</style>
